<template>
  <div class="service-no-moist-alarm">
    <p>
      {{ $t('messages.alarms.serviceNoMoistAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <div class="g-alarm-handler__row">
      <!-- <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>

      <div class="g-alarm-handler__numbered-list">
        <ol>
          <li>
            <p>
              {{ $t('messages.alarms.serviceNoMoistAlarm.suggestion') }}
            </p>
          </li>
          <li>
            <p>{{ $t('messages.alarms.serviceNoMoistAlarm.suggestionRepeat') }}</p>
          </li>
        </ol>
      </div> -->

      <p>
        {{ $t('messages.alarms.serviceNoMoistAlarm.label') }}:
      </p>
    </div>

    <div class="g-alarm-handler__row">
      <p class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow">
        <strong>{{ $t('messages.alarms.attention') }}:</strong> {{ $t('messages.alarms.serviceNoMoistAlarm.attention') }}
      </p>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceNoMoistAlarm',
  mixins: [ServiceAlarm]
}
</script>
